import { values } from 'lodash'
import React from 'react'
import { Range, getTrackBackground } from 'react-range'

const RangePicker = ({ min, max, onChange, onFinalChange, value, step }) => {
    return (
        <Range
            values={[value]}
            step={step}
            min={min}
            max={max}
            onChange={(values) => onChange(values[0])}
            onFinalChange={(values) => {
                onFinalChange([values[0]])
            }}
            renderTrack={({ props, children }) => (
                <div
                    style={{
                        ...props.style,
                        height: '36px',
                        display: 'flex',
                        width: '100%',
                    }}
                >
                    <div
                        ref={props.ref}
                        style={{
                            height: '5px',
                            width: '100%',
                            borderRadius: '4px',
                            background: getTrackBackground({
                                values: [value],
                                colors: ['#1065B0', '#ccc'],
                                min: min,
                                max: max,
                            }),
                            alignSelf: 'center',
                        }}
                    >
                        {children}
                    </div>
                </div>
            )}
            renderThumb={({ props, isDragged }) => (
                <div
                    {...props}
                    style={{
                        ...props.style,
                        height: '18px',
                        cursor: 'default',
                        width: '18px',
                        borderRadius: '4px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: "url('/images/mokaber-icon.svg')",
                        backgroundSize: 'cover',
                    }}
                >
                    <div
                        style={{
                            height: '12px',
                            width: '5px',
                        }}
                    />
                </div>
            )}
            getTrackBackground={{
                min: -100,
                max: 100,
                values: [value],
                colors: ['red'],
            }}
        />
    )
}

export default RangePicker
